import React from 'react';

export const naira = (n: number) =>
  `${n < 0 ? '−' : ''}₦${Math.abs(n).toLocaleString('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

/** For chart axes, where ₦1,234,567.00 does not fit. */
export const compact = (n: number) => {
  const a = Math.abs(n);
  const sign = n < 0 ? '−' : '';
  if (a >= 1_000_000_000) return `${sign}₦${(a / 1_000_000_000).toFixed(1)}bn`;
  if (a >= 1_000_000) return `${sign}₦${(a / 1_000_000).toFixed(1)}m`;
  if (a >= 1_000) return `${sign}₦${(a / 1_000).toFixed(0)}k`;
  return `${sign}₦${a.toFixed(0)}`;
};

export const count = (n: number) => n.toLocaleString('en-NG');

/** A price per unit can be a fraction of a kobo: show what was typed. */
export const price = (n: number, currency: string) =>
  `${currency === 'USD' ? '$' : '₦'}${n.toLocaleString('en-NG', { maximumFractionDigits: 4 })}`;

export const longDate = (day: string) =>
  new Date(`${day}T12:00:00`).toLocaleDateString('en-NG', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

export const monthLabel = (month: string) =>
  new Date(`${month}-01T12:00:00`).toLocaleDateString('en-NG', { month: 'short', year: 'numeric' });

/** YYYY-MM-DD in the viewer's own calendar, which for PayIQ staff is Lagos. */
export const isoDay = (d: Date) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const th: React.CSSProperties = {
  padding: '10px 14px',
  textAlign: 'left',
  fontSize: 12,
  fontWeight: 600,
  color: 'var(--neutral-600)',
  textTransform: 'uppercase',
  letterSpacing: 0.4,
  whiteSpace: 'nowrap',
};

export const thRight: React.CSSProperties = { ...th, textAlign: 'right' };

export const td: React.CSSProperties = {
  padding: '12px 14px',
  verticalAlign: 'top',
  borderTop: '1px solid var(--neutral-200)',
  fontSize: 14,
};

export const tdRight: React.CSSProperties = {
  ...td,
  textAlign: 'right',
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
};

export const sectionTitle: React.CSSProperties = {
  margin: '0 0 4px',
  fontSize: 16,
  fontWeight: 600,
  color: 'var(--neutral-900)',
};

export const sectionNote: React.CSSProperties = {
  margin: '0 0 16px',
  fontSize: 13,
  color: 'var(--neutral-600)',
  maxWidth: 720,
};

export const muted: React.CSSProperties = { fontSize: 12, color: 'var(--neutral-500)', marginTop: 2 };

export const fieldLabel: React.CSSProperties = { fontSize: 13, fontWeight: 500, color: 'var(--neutral-700)' };

export const select: React.CSSProperties = {
  padding: '0 12px',
  fontSize: 14,
  fontFamily: 'var(--font-family)',
  color: 'var(--neutral-800)',
  background: 'var(--neutral-100)',
  border: '1px solid var(--neutral-300)',
  borderRadius: 'var(--radius-md)',
  height: 40,
};

/** Money in and money out: two hues that stay apart for colour-blind readers. */
export const SERIES = {
  revenue: '#1F7FA8',
  costs: '#C2410C',
  net: '#2B3036',
};
